// assets
import { AndroidOutlined, DashboardOutlined } from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  AndroidOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  // title: 'Navigation',
  type: 'group',
  children: [
    // {
    //   id: 'dashboard',
    //   title: 'Dashboard',
    //   type: 'item',
    //   url: '/dashboard',
    //   icon: icons.DashboardOutlined,
    //   breadcrumbs: false
    // },
    {
      id: 'assistant',
      title: 'Assistant',
      type: 'item',
      url: '/assistant',
      icon: icons.AndroidOutlined,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
